import { Button } from "primereact/button";

type PaymentMethodPanelProps = {
  paymentMethodSummary: any;
  onUpdate: () => void;
  loading?: boolean;
  title?: string;
  description?: string;
  emptyDescription?: string;
  className?: string;
  showActionButton?: boolean;
};

const PaymentMethodPanel = ({
  paymentMethodSummary,
  onUpdate,
  loading = false,
  title = "Payment Method",
  description = "Saved customer card used for subscription updates and one-time bundle purchases.",
  emptyDescription = "No saved customer card is available yet.",
  className = "",
  showActionButton = true,
}: PaymentMethodPanelProps) => {
  const paymentMethodTitle = paymentMethodSummary?.displayName
    || (paymentMethodSummary?.last4 ? `${String(paymentMethodSummary.brand || "").toUpperCase()} ending in ${paymentMethodSummary.last4}` : paymentMethodSummary?.typeLabel)
    || "Saved payment method";
  const paymentMethodDetail = paymentMethodSummary?.detailLine
    || (paymentMethodSummary?.expMonth && paymentMethodSummary?.expYear ? `Expires ${paymentMethodSummary.expMonth}/${paymentMethodSummary.expYear}` : null);

  return (
    <div
      className={className}
      style={{
        background: "#ffffff",
        border: "1px solid #e2e8f0",
        borderRadius: "14px",
        padding: "1rem",
      }}
    >
      <div className="flex flex-wrap align-items-start justify-content-between gap-3">
        <div>
          <div style={{ fontSize: "0.82rem", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.06em" }}>
            {title}
          </div>
          {paymentMethodSummary ? (
            <>
              <div className="mt-2" style={{ fontWeight: 700, color: "#0f172a" }}>
                {paymentMethodTitle}
              </div>
              {paymentMethodDetail && (
                <div className="mt-1" style={{ color: "#64748b" }}>
                  {paymentMethodDetail}
                </div>
              )}
              <div className="mt-2" style={{ color: "#596F80", lineHeight: 1.7 }}>
                {description}
              </div>
            </>
          ) : (
            <div className="mt-2" style={{ color: "#596F80", lineHeight: 1.7 }}>
              {emptyDescription}
            </div>
          )}
        </div>
        {showActionButton && (
          <Button
            label={paymentMethodSummary ? "Update Payment Method" : "Add Payment Method"}
            severity="warning"
            rounded
            outlined
            onClick={onUpdate}
            loading={loading}
            data-telemetry-action="billing_manage_payment_method"
          />
        )}
      </div>
    </div>
  );
};

export default PaymentMethodPanel;
